var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublisherCheckPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 451.668,
    height: 239.199,
    viewBox: "0 0 451.668 239.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(-344.481 -511.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(391.999 515.533)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_27",
    "data-name": "Rectangle Copy 27",
    width: 403.65,
    height: 179.816,
    rx: 2,
    fill: "none",
    stroke: "#d6dade",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "_40",
    "data-name": 40,
    transform: "translate(351.481 550.533) rotate(-90)",
    fill: "#cbced2",
    fontSize: 9,
    fontFamily: "GothamPro, Gotham Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -111.042,
    y: 0
  }, "Percentage of publishers")), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(381.411 686.889)",
    fill: "#cbced2",
    fontSize: 8,
    fontFamily: "GothamPro-Medium, Gotham Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.792,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "_20",
    "data-name": 20,
    transform: "translate(381.356 651.361)",
    fill: "#cbced2",
    fontSize: 9,
    fontFamily: "GothamPro-Medium, Gotham Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.033,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    id: "_40-2",
    "data-name": 40,
    transform: "translate(380.356 613.952)",
    fill: "#cbced2",
    fontSize: 8,
    fontFamily: "GothamPro-Medium, Gotham Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.24,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    id: "_60",
    "data-name": 60,
    transform: "translate(381.356 579.322)",
    fill: "#cbced2",
    fontSize: 9,
    fontFamily: "GothamPro-Medium, Gotham Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.42,
    y: 0
  }, "60")), /*#__PURE__*/React.createElement("text", {
    id: "_80",
    "data-name": 80,
    transform: "translate(380.491 542.869)",
    fill: "#cbced2",
    fontSize: 9,
    fontFamily: "GothamPro-Medium, Gotham Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.186,
    y: 0
  }, "80")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(382.031 507.283)",
    fill: "#cbced2",
    fontSize: 9,
    fontFamily: "GothamPro-Medium, Gotham Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.596,
    y: 0
  }, "100"))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 403.75,
    transform: "translate(391.413 660.564)",
    fill: "none",
    stroke: "#d6dade",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 403.75,
    transform: "translate(391.413 624.161)",
    fill: "none",
    stroke: "#d6dade",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 403.75,
    transform: "translate(391.413 587.757)",
    fill: "none",
    stroke: "#d6dade",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 403.75,
    transform: "translate(391.413 554.599)",
    fill: "none",
    stroke: "#d6dade",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 180.043,
    transform: "translate(595.604 515.608)",
    fill: "none",
    stroke: "#d6dade",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 140.123,
    height: 132.339,
    transform: "translate(424.5 562.98)",
    fill: "#cbced2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 140.123,
    height: 38.923,
    transform: "translate(424.5 540.692)",
    fill: "#dcdfe2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 140.123,
    height: 25.084,
    transform: "translate(424.5 515.608)",
    fill: "#edeff0"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_80-2",
    "data-name": 80,
    transform: "translate(494.5 634.401)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.245,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "_80-3",
    "data-name": 80,
    transform: "translate(494.5 559.878)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.245,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "_80-4",
    "data-name": 80,
    transform: "translate(494.5 529.416)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.82,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(503.604 732.482)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0-2",
    "data-name": 0,
    transform: "translate(21 12)",
    fill: "#cbced2",
    fontSize: 8,
    fontFamily: "GothamPro, Gotham Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pass")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 18,
    height: 18,
    rx: 4,
    fill: "#cbced2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(573.604 732.482)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0-3",
    "data-name": 0,
    transform: "translate(22 12)",
    fill: "#cbced2",
    fontSize: 8,
    fontFamily: "GothamPro, Gotham Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Review")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 18,
    height: 18,
    rx: 4,
    fill: "#dcdfe2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(651.604 732.482)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0-4",
    "data-name": 0,
    transform: "translate(22 12)",
    fill: "#cbced2",
    fontSize: 8,
    fontFamily: "GothamPro, Gotham Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fail")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 18,
    height: 18,
    rx: 4,
    fill: "#edeff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(628.5 563.661)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 140,
    height: 132,
    fill: "#cbced2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 140.123,
    height: 38.058,
    transform: "translate(628.5 529.777)",
    fill: "#dcdfe2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 140.123,
    height: 16.434,
    transform: "translate(628.5 515.072)",
    fill: "#edeff0"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_80-5",
    "data-name": 80,
    transform: "translate(698.5 632.7)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.245,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "_80-6",
    "data-name": 80,
    transform: "translate(698.5 548.86)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.82,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "_80-7",
    "data-name": 80,
    transform: "translate(698.5 524.816)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.82,
    y: 0
  }, "%")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublisherCheckPlaceholder);
export default __webpack_public_path__ + "static/media/publisher-check-placeholder.361be17c997fac6fc4b060f776a714da.svg";
export { ForwardRef as ReactComponent };